import loadable from '@loadable/component';

export const MyimperfectlifeSiteWrapper = loadable(
  () => import(/* webpackChunkName: "myimperfectlife-site" */ './MyimperfectlifeSiteWrapper'),
);
